import Game from './Game.svelte'

const app = new Game({
  target: document.body,
  props: {
    name: 'Hula Words'
  }
})

export default app;
